import { render, staticRenderFns } from "./newDahboard.vue?vue&type=template&id=4be411da&"
import script from "./newDahboard.vue?vue&type=script&lang=js&"
export * from "./newDahboard.vue?vue&type=script&lang=js&"
import style0 from "./newDahboard.vue?vue&type=style&index=0&id=4be411da&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports